import React, { useRef } from "react";
import OutletSellTable from "./OutletSellTable";
import { styles } from "../styles/ProductLevelChallanData";
import { redFadeWhite } from "../../../config/ColorObj";

const ExpandPanel = ({ isOpen, rows, COL_IDX_W, COL_PROD_W }) => {
    const ref = useRef(null);

    return (
        <tr>
            <td style={{ width: COL_IDX_W }} />
            <td style={{ width: COL_PROD_W }} />

            <td colSpan={9} style={{ padding: 0 }}>
                <div
                    ref={ref}
                    style={{
                        ...styles.expandInner,
                        borderLeft: "1px solid #d1d5db",
                        maxHeight: isOpen
                            ? ref.current?.scrollHeight + 200 || 400
                            : 0,
                        opacity: isOpen ? 1 : 0,
                        background: redFadeWhite,
                    }}
                >
                    <OutletSellTable rows={rows} />
                </div>
            </td>
        </tr >
    );
};

export default React.memo(ExpandPanel);